import { Pipe, PipeTransform } from '@angular/core';
import { DateOrString } from './months-between.pipe';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'spendDateRange',
    standalone: false
})
export class SpendDateRangePipe implements PipeTransform {
  datePipe = new DatePipe('en-US');
  transform({
    startDate,
    endDate,
    format,
  }: {
    startDate: DateOrString;
    endDate: DateOrString;
    format?: string;
  }): string {
    return (
      (this.datePipe.transform(startDate, format ? format : 'MMM d, y') || '') +
      ' - ' +
      (this.datePipe.transform(endDate, format ? format : 'MMM d, y') || '')
    );
  }
}
